var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoupe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#b8b8b8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.756 18.578l-5.688-5.688c1.102-1.36 1.765-3.09 1.765-4.973C15.833 3.552 12.282 0 7.917 0S0 3.552 0 7.917s3.552 7.916 7.917 7.916c1.883 0 3.612-.663 4.973-1.765l5.687 5.688c.163.162.376.244.59.244.213 0 .426-.082.589-.244.325-.326.325-.853 0-1.178zm-11.84-4.411c-3.446 0-6.25-2.804-6.25-6.25 0-3.447 2.804-6.25 6.25-6.25 3.447 0 6.25 2.803 6.25 6.25 0 3.446-2.803 6.25-6.25 6.25z",
    transform: "translate(-120 -321) translate(120 321)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoupe);
export default __webpack_public_path__ + "static/media/loupe.3b24e85cb53b6c43f9ea19c8cfe7fc53.svg";
export { ForwardRef as ReactComponent };